import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { OrderApi } from "@/config/apiClient";
import { createApiClient } from "@/config/createApiClient";
import { currentWorkspaceAtom } from "@/store";

type QueryGetOrders = {
  orderId: string;
};

const apiClient = createApiClient(OrderApi);

export const useDocuments = () => {
  const currentWorkspace = useAtomValue(currentWorkspaceAtom);

  const useGetDocuments = ({ orderId }: QueryGetOrders) =>
    useQuery({
      queryKey: ["documents", orderId],
      enabled: !!currentWorkspace,
      queryFn: () => {
        return apiClient.ordersControllerGetOrderDocuments({
          accountId: currentWorkspace?.accountId,
          organizationId: currentWorkspace?.organizationId,
          workspaceId: currentWorkspace?.id,
          orderId,
        });
      },
    });

  return {
    useGetDocuments,
  };
};
